import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { en, fa, ar, ru, tr, fr, it, de, es } from '@shared/i18n';
import { SUPPORTED_LOCALES } from './utils/locale';
const resources = {
    en: { translation: en },
    fa: { translation: fa },
    ar: { translation: ar },
    ru: { translation: ru },
    tr: { translation: tr },
    fr: { translation: fr },
    it: { translation: it },
    de: { translation: de },
    es: { translation: es },
};
if (!i18n.isInitialized) {
    i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
        resources,
        fallbackLng: 'en',
        supportedLngs: SUPPORTED_LOCALES,
        nonExplicitSupportedLngs: true,
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'projectmanmd-locale',
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
    });
}
export default i18n;
//# sourceMappingURL=i18n.js.map